import { environment } from '../../../environments/environment';

export function getEnvironmentBaseUrl(): string {
  const env = environment as { baseUrl?: string; apiUrl?: string };
  if (env.baseUrl) {
    return env.baseUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');
  }
  if (env.apiUrl) {
    try {
      const { protocol, host } = new URL(env.apiUrl);
      return `${protocol}//${host}`;
    } catch {
      /* fall through */
    }
  }
  return typeof window !== 'undefined' ? window.location.origin : '';
}

export function getWebsitePlatformHost(): string {
  const env = environment as { websitePlatformHost?: string };
  if (env.websitePlatformHost) {
    return env.websitePlatformHost;
  }
  try {
    return new URL(getEnvironmentBaseUrl()).host;
  } catch {
    return '';
  }
}

export function getReferrerUrl(): string {
  if (typeof document !== 'undefined' && document.referrer) {
    return document.referrer;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return getEnvironmentBaseUrl();
}

export function getBaseWebsiteUrl(pageData?: any): string {
  const data = pageData as { json_data?: { website?: WebsiteFields }; website?: WebsiteFields } | null | undefined;
  const website = data?.json_data?.website ?? data?.website;

  if (website?.custom_domain) {
    return normalizeUrl(website.custom_domain);
  }
  if (website?.subdomain) {
    return `https://${website.subdomain}.${getWebsitePlatformHost()}`;
  }
  if (website?.domain) {
    return normalizeUrl(website.domain);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return getEnvironmentBaseUrl();
}

interface WebsiteFields {
  custom_domain?: string;
  subdomain?: string;
  domain?: string;
}

function normalizeUrl(value: string): string {
  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }
  return `https://${value}`;
}
